import { createFileRoute } from "@tanstack/react-router";

import { OrganizationSettingsLayoutPage } from "src/pages/OrganizationSettingsLayoutPage";
import { getOrganizationSettingsSidebarConfig } from "src/staticData";

export const Route = createFileRoute("/_auth/_coach/orgs/$slug/settings")({
  component: OrganizationSettingsLayoutPage,
  ssr: true,
  staticData: {
    getLayoutSettings(ctx) {
      return {
        authNavigationTitle: ctx.i18n.t("settings"),
        sidebar: getOrganizationSettingsSidebarConfig(ctx, ctx.params.slug),
      };
    },
  },
});
